import * as React                                                        from 'react';
import ReactDOM                                                          from "react-dom";
import * as messageBroadcast                                             from '../../../../helpers/messageBroadcast';
import { NotificationOptions, NotificationItem, NotificationComponent, } from "../../interfaces/notifications";
import styles                                                            from './NotificationsContainer.scss';

const MAX_EVENTS_COUNT = 10;
const DEFAULT_TIMEOUT = 40;
let _instance: NotificationsContainer | null = null;

export const openNotification = <Props extends {}>(component: NotificationComponent<Props>, props: Props, options?: Partial<NotificationOptions>): NotificationItem<Props> => {
  if (!_instance) throw('NotificationsContainer не смонтирован');
  return _instance.open(component, props, options);
}

export const closeNotification = (...args: Parameters<NotificationsContainer['onCloseItem']>) => {
  if (!_instance) throw('NotificationsContainer не смонтирован');
  return _instance.onCloseItem.apply(_instance, args);
}

type Props = {
  targetElementId?: string
};
type State = {
  items: Array<NotificationItem<any>>
};

export default class NotificationsContainer extends React.PureComponent<Props, State> {
  state: State = {
    items: [],
  };

  processing: { [notificationId: string]: boolean } = {};
  messageListener: ReturnType<typeof messageBroadcast.listen> | null = null;

  componentDidMount() {
    if (_instance) console.warn('NotificationsContainer уже существует');
    _instance = this;

    this.messageListener = messageBroadcast.listen('NOTIFICATIONS:CLOSE', this.onCloseItem);
  }

  componentWillUnmount(): void {
    _instance = null;
    if (this.messageListener) {
      this.messageListener();
      this.messageListener = null;
    }
  }

  open = <Props extends {}>(component: NotificationComponent<Props>, props: Props, options?: Partial<NotificationOptions>): NotificationItem<Props> => {
    const { id, timeout } = options || {};
    const item: NotificationItem<Props> = {
      component,
      id:      id || ('' + Date.now()),
      key:     null,
      timeout: timeout || DEFAULT_TIMEOUT,
      props,
      timer:   null,
      close:   this.onCloseItem,
    };
    item.key = item.id;

    const append = () => {
      let items = this.state.items.concat(item);
      if (items.length > MAX_EVENTS_COUNT) items = items.slice(items.length - MAX_EVENTS_COUNT);

      this.setState({ items });

      item.timer = setTimeout(() => {
        this.onCloseItem(item.id);
      }, item.timeout * 1000);
    };

    append();

    return item;
    // if (typeof init === 'function') {
    //   const ready = init(props);
    //   if (ready && ready.then) {
    //     this.processing[notification.id] = true;
    //     ready
    //       .then(() => {
    //         if (this.processing[notification.id]) append();
    //       })
    //       .finally(() => {
    //         delete this.processing[notification.id];
    //       });
    //   } else {
    //     append();
    //   }
    // } else {
    //   append();
    // }
  };

  clear() {
    this.setState({ items: [] });
    this.processing = {};
  }

  onCloseItem = (id: string) => {
    const items = this.state.items.filter((item) => item.id !== id);
    if (items.length !== this.state.items.length) {
      this.setState({ items }, () => {
        messageBroadcast.broadcast('NOTIFICATIONS:CLOSE', id);
      });
      delete this.processing[id];
    }
  };

  renderItem = (item: NotificationItem) => {
    const Component = item.component
    return <Component {...item} />;
  };

  renderContent() {
    const { items } = this.state;
    return (
      <div className={styles.container}>
        <React.Suspense fallback={null}>
          {items.map(this.renderItem)}
        </React.Suspense>
      </div>
    );
  }

  render() {
    return ReactDOM.createPortal(
      this.renderContent(),
      document.getElementById(this.props.targetElementId || 'notifications')
    );
  }
}
